<template>
    <article class="blog-post clearfix">
        <img v-if="imageUrl"
             :src="imageUrl"
             :alt="post.title"
             :class="{'blog-image': true, 'with-margin': post.content }">
        <div v-html="post.content"></div>
    </article>
</template>

<script>
export default {
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    computed: {
        imageUrl() {
            return this.post.image ? `https://blog.rmy.ch${this.post.image}` : null;
        },
    },
}
</script>

<style scoped>
.blog-post {
    float: left;
    width: 75%;
    background-color: #EEEEEE;
    padding: 20px;
    overflow-y: auto;
}
/* TODO: Loading state
.blog-post.loading {
    opacity: 0.5;
    background: url('/images/ajax-loader.gif') no-repeat center 150px;
}
.blog-post.loading img {
    opacity: 0.2;
}

 */
@media screen and (max-width:979px) { /* Small screens */
    .blog-post {
        width: 100%;
    }
}

@media screen and (max-width:767px) { /* Tablets */
    .blog-post {
        padding: 10px;
    }
}

@media screen and (max-width:479px) { /* Phones */
    .blog-post {
        padding: 0;
    }
    .blog-image {
        border-radius: 0;
    }
    .blog-post p {
        padding-left: 10px;
        padding-right: 10px;
    }
    .blog-post > p:last-child {
        padding-bottom: 10px;
    }
}
.blog-post p {
    padding-top: 1em;
}
.blog-post ul {
    padding-top: 1em;
    padding-left: 20px;
}
.blog-post a {
    color: #666699;
}
.blog-image {
    background-color: #FFFFFF;
    max-width: 100%;
    display: block;
    border-radius: 3px;
    margin: auto;
}
.blog-image.with-margin {
    margin-bottom: 20px;
}
</style>
